import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { DialogActions, Dialog, Button } from '@material-ui/core'
import ActionType from '../../actions/ActionType'

import LinearProgress from '@material-ui/core/LinearProgress'
import { closeBulkUploadDialog } from '../../actions/contacts/addOrEdit'
import { bulkUpload } from '../../actions/contacts'
import  BulkUploadMapper from './BulkUploadMapper'
import { getGroup } from '../../actions/contacts/groups'
const { Contacts } = ActionType
const dispatchType = (type, payload) => (dispatch) =>
  dispatch({ type, payload })
const mapStateToProps = state => ({
  modalOpen: state.contacts.bulkUploadModalOpen,
  bulkUploadInProgress: state.contacts.bulkUploadInProgress,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  closeBulkUploadDialog,
  receiveGroup: (payload) => dispatchType(Contacts.RECEIVE_GROUP, payload),
  bulkUpload,
  getGroup
}, dispatch)

const styles = theme => ({

})

class BulkUploadDialog extends Component {
  handleDialogClose = () => {
    if(this.props.uploadToGroupId){
      this.props.getGroup(this.props.uploadToGroupId).then((payload) => this.props.receiveGroup(payload))
    }
    this.props.closeBulkUploadDialog()
  }
  onClose = () =>{
    console.log("on close")
    if (this.props.uploadToGroupId) {
      this.props.getGroup(this.props.uploadToGroupId)
    }
  }
  onDrop = (acceptedFiles, rejectedFiles) => {
    console.log(acceptedFiles)
    this.props.bulkUpload(acceptedFiles)
  }

  render() {
    console.log("groupIDPassed", this.props.uploadToGroupId)
    return (

      <Dialog
        open={this.props.modalOpen}
        maxWidth={"xl"}
        onClose={this.onClose}
        >

        {
          this.props.bulkUploadInProgress ?
            <div style={{ margin: '40px', minWidth:500 }}><LinearProgress color="secondary" /> </div> :
            <div>
      
              <BulkUploadMapper uploadToGroupId = {this.props.uploadToGroupId}/>
            </div>
        }
        <DialogActions>
          <Button onClick={this.handleDialogClose}>Close</Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(BulkUploadDialog))
